<template>
  <div class="flex items-start">
    <div class="w-12 justify-items-center">
      <UspIcon v-if="trait.kind === 'certificate'" :disabled="hintMissingTranslation" />
      <CertIcon v-else :disabled="hintMissingTranslation" />
    </div>
    <div class="pb-6">
      <div class="text-body-m-bold" :class="{ 'text-subtlest': hintMissingTranslation }">{{ titleWithFallback }}</div>
      <div :class="{ 'text-subtlest': hintMissingTranslation }">{{ descriptionWithFallback }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import type { AgencyTranslatedTrait } from '@/gql/reviews'

const props = defineProps<{
  trait: AgencyTranslatedTrait
  language: string
  fallbackLanguage: string
}>()

const hintMissingTranslation = computed(() => {
  return props.language == 'en' && (props.trait.title?.en === '' || props.trait.description?.en === '')
})

const titleWithFallback = computed(() => {
  return props.trait.title && props.trait.title[props.language]
    ? props.trait.title[props.language]
    : props.trait.title?.[props.fallbackLanguage]
})

const descriptionWithFallback = computed(() => {
  return props.trait.description && props.trait.description[props.language]
    ? props.trait.description[props.language]
    : props.trait.description?.[props.fallbackLanguage]
})
</script>
